import { ShiftEntity, ShiftFilter } from '../../models'

export const SET_SHIFTS = 'SET_SHIFTS'
export const SET_SHIFTS_LOADED = 'SET_SHIFTS_LOADED'
export const SET_SELECTED_SHIFT = 'SET_SELECTED_SHIFT'
export const SET_SHIFT_FILTER = 'SET_SHIFT_FILTER'

export interface ShiftState {
  shifts: ShiftEntity[]
  isShiftsLoaded: boolean
  selectedShift?: ShiftEntity
  shiftFilter: ShiftFilter
}

interface SetShiftsAction {
  type: typeof SET_SHIFTS
  payload: ShiftEntity[]
}

interface SetShiftsLoadedAction {
  type: typeof SET_SHIFTS_LOADED
  payload: boolean
}

interface SetSelectedShiftAction {
  type: typeof SET_SELECTED_SHIFT
  payload?: ShiftEntity
}

interface SetShiftFilterAction {
  type: typeof SET_SHIFT_FILTER
  payload: ShiftFilter
}

export type ShiftAction =
  | SetShiftsAction
  | SetShiftsLoadedAction
  | SetSelectedShiftAction
  | SetShiftFilterAction
